export const home_texts: string[] = [
    "texts.1",
    "texts.2",
    "texts.3",
]

export const destination_texts: string[] = [
    "texts.1",
    "texts.2",
    "texts.3",
    "texts.4",
]